/** @jsx jsx */
import React from 'react'
import { navigate } from 'gatsby'
import { jsx, Button as ThemeButton } from 'theme-ui'

import Paragraph from '../Typography/Paragraph/Paragraph'
import { Window } from '../../../utils'
import { checkForHtmlLink } from '../Typography/Link/Link'

function checkSize(size) {
  if (size === 'large') {
    return { minWidth: '300px', height: '64px' }
  } else if (size === 'medium') {
    return { width: 'auto', height: '48px' }
  } else if (size === 'small') {
    return { width: 'auto', height: '42px' }
  } else {
    return { width: 'auto', height: '48px' }
  }
}

const Button = React.forwardRef(
  (
    {
      children,
      size,
      paragraphVariant = 'buttonLabel',
      paragraphOptions,
      ...props
    },
    ref
  ) => {
    if (props.to) {
      props.onClick = () => {
        if (checkForHtmlLink(props.to)) {
          props.newTab
            ? Window && Window.open(props.to, '_blank')
            : navigate(props.to)
        } else {
          navigate(props.to.startsWith('/') ? props.to : `/${props.to}`)
        }
      }
    }

    return (
      <ThemeButton
        ref={ref}
        sx={{
          ...checkSize(size),
          cursor: 'pointer',
          ...props.styles,
        }}
        aria-label={children}
        {...props}
      >
        <Paragraph variant={paragraphVariant} {...paragraphOptions}>
          {children}
        </Paragraph>
      </ThemeButton>
    )
  }
)

export default Button
